import React from 'react'
import { Link } from 'react-router-dom'

interface AppBackBtnProps {
  to: string
}

class AppBackBtn extends React.Component<AppBackBtnProps> {
  render() {
    return (
      <div className="w-full max-w-screen-md mx-auto px-4 py-2 sm:px-6 lg:px-8">
        <Link to={this.props.to}>
          <button
            className="w-full flex flex-row items-center justify-center gap-x-3 flex-nowrap text-white font-semibold py-3"
            aria-label="Назад"
            style={{ borderRadius: '12px', background: 'rgba(255, 255, 255, 0.1)' }}
          >
            <span>
              <i className="far fa-chevron-left"></i>
            </span>
            <span>Главная</span>
          </button>
        </Link>
      </div>
    )
  }
}

export default AppBackBtn
